import { i18n } from '@lt/localization';
import * as Yup from 'yup';

const cyrillicRegex = /^[\u0400-\u04FF-]+$/; // Регулярное выражение для проверки кириллических символов
const enRegex = /^[a-zA-Z]+$/; // Регулярное выражение для проверки латинских символов
const russianPassportNumberRegex = /^[0-9]{4}\s?[0-9]{6}$/; // Регулярное выражение для номера паспорта РФ
const internationalPassportNumberRegex = /[A-Za-zА-Яа-яёЁ\u0400-\u04FF\- .]+/; // Регулярное выражение для заграна
const birthdayRegex = /^[0-9]{2}.[0-9]{2}.[0-9]{4}$/;

export const CustomerSchemaRu = Yup.object().shape({
  name: Yup.string()
    .matches(
      cyrillicRegex,
      i18n.t('checkout.customer.errors.only_cyrillic_symbols'),
    )
    .required(i18n.t('checkout.customer.errors.name'))
    .nullable(),
  surname: Yup.string()
    .matches(
      cyrillicRegex,
      i18n.t('checkout.customer.errors.only_cyrillic_symbols'),
    )
    .required(i18n.t('checkout.customer.errors.surname'))
    .nullable(),
  patronymic: Yup.string()
    .matches(
      cyrillicRegex,
      i18n.t('checkout.customer.errors.only_cyrillic_symbols'),
    )
    .required(i18n.t('checkout.customer.errors.patronymic'))
    .nullable(),
  passportNumber: Yup.string()
    .matches(
      russianPassportNumberRegex,
      i18n.t('checkout.customer.errors.russian_passport'),
    )
    .required(i18n.t('checkout.customer.errors.passport_number'))
    .nullable(),

  birthday: Yup.string()
    .matches(birthdayRegex, i18n.t('checkout.customer.errors.birthday'))
    .required(i18n.t('checkout.customer.errors.birthday'))
    .nullable(),

  nationalityId: Yup.number().required().nullable(),
});

export const CustomerSchemaInternational = Yup.object().shape({
  name: Yup.string()
    .matches(enRegex, i18n.t('checkout.customer.errors.only_en_symbols'))
    .required(i18n.t('checkout.customer.errors.name'))
    .nullable(),
  surname: Yup.string()
    .matches(enRegex, i18n.t('checkout.customer.errors.only_en_symbols'))
    .required(i18n.t('checkout.customer.errors.surname'))
    .nullable(),
  passportNumber: Yup.string()
    .matches(
      internationalPassportNumberRegex,
      i18n.t('checkout.customer.errors.international_passport'),
    )
    .required(i18n.t('checkout.customer.errors.passport_number'))
    .nullable(),
  birthday: Yup.string()
    .matches(birthdayRegex, i18n.t('checkout.customer.errors.birthday'))
    .required(i18n.t('checkout.customer.errors.birthday'))
    .nullable(),
  nationalityId: Yup.number().required().nullable(),
});
